import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-navy-50 p-8">
          <div className="max-w-md text-center">
            <div className="text-6xl mb-6 opacity-40">⚠️</div>
            <h1 className="font-sora text-2xl font-extrabold text-navy-800 mb-3">
              Something went wrong
            </h1>
            <p className="text-navy-400 text-sm mb-6 leading-relaxed">
              An unexpected error occurred. Please refresh the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl bg-navy-800 text-white font-sora font-bold text-sm
                         cursor-pointer border-none transition-all duration-200 hover:bg-navy-700"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
